import moment = require("moment");


export const getDate0 = (date: Date = new Date): Date => moment(date).startOf('day').toDate();
